import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CreateNewFolder } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import LoupeIcon from "@mui/icons-material/Loupe";
import BrushIcon from '@mui/icons-material/Brush';

export const createExamOverview = (openDialogNewExam: () => void, openDialogNewFolder: () => void, open: boolean) => [
  {
    text: "Neue Prüfung",
    icon: <AddCircleIcon />,
    open,
    action: openDialogNewExam,
  },
  {
    text: "Neuer Ordner",
    icon: <CreateNewFolder />,
    open,
    action: openDialogNewFolder,
  },
];

export const createExamBuilder = (
  openDialogTopics: () => void,
  openDialogExcercises: () => void,
  openDialogPrint: () => void,
  openDialogChangeLayout: () => void,
  showSolutions: () => void,
  handleSaveExam: () => void,
  handleCheckChangesLeavePage: () => void,
  open: boolean
) => [
  {
    text: "Kompetenzen auswählen",
    icon: <LoupeIcon />,
    open,
    action: openDialogTopics,
  },
  {
    text: "Aufgaben hinzufügen",
    icon: <NoteAddIcon />,
    open,
    action: openDialogExcercises,
  },
  {
    text: "Lösungen anzeigen",
    icon: <CheckCircleIcon />,
    open,
    action: showSolutions,
  },
  {
    text: "Drucken",
    icon: <PrintIcon />,
    open,
    action: openDialogPrint,
  },
    {
    text: "Layout wechseln",
    icon: <BrushIcon />,
    open,
    action: openDialogChangeLayout,
  },
  {
    text: "Speichern",
    icon: <SaveIcon />,
    open,
    action: handleSaveExam,
  },
  {
    text: "Zurück zur Übersicht",
    icon: <ArrowBackIosNewIcon />,
    open,
    action: handleCheckChangesLeavePage,
  },
];
